import PollQuestions from './PollQuestions';
export default PollQuestions;
